import api from "./axios";

export async function getReservaAlumnosIds(reservaId: number) {
  const { data } = await api.get<number[]>(`/reservas/${reservaId}/alumnos-ids`);
  return Array.isArray(data) ? data : [];
}
